<template>
  <div class="container-fluid">
    <div class="d-flex align-items-center justify-content-between mb-4">
      <div>
        <h5 class="mb-0 font-weight-bold">Plan Management</h5>
        <p class="text-secondary text-sm mb-0">Test Plan &amp; Task tracking</p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <test-plan-table />
      </div>
    </div>
  </div>
</template>

<script>
import TestPlanTable from "./components/TestPlanTable";

export default {
  name: "test-plan",
  components: {
    TestPlanTable,
  },
};
</script>
